import $ from "jQuery";
import { Runner, TestPlanProgression, Actuator, Logger } from "./models";
import * as machinemotion from '../../api/machinemotion';
import configCheckerPersistency from './configCheckerPersistency';
import immediateApi from "../../api/immediateApi";
import cc_widgets from './configChecker_widgets';
import { setHasConnection, registerLeaveConfigChecker } from './configChecker_helpers';
import { getMlConfig, setMlConfig } from './configState';
import { stopAll as stopMotionOnAllControllers } from "@vse/machine_app/machineapp_utils";
//Tests
import verifyDriveNumber from "./testDefinitions/driveNumberTest";
import verifyAxisDirection from "./testDefinitions/axisDirection";
import verifyHomeSensor from "./testDefinitions/homeSensorTest";
import verifyEndSensor from "./testDefinitions/endSensorTest";

// --------------------------------------------------
// DEV TOOLS
const ECHO = true;
// --------------------------------------------------

let gLogger;

let gInitialActuatorConfig;
let gActuator;

const _style = window._style;

// --------------------------------------------------
// Parent Widget for Config Checker Test Page
// --------------------------------------------------

/**
 * @param {JQuery} container
 * @param {string} pTargetActuatorUuid
 * @param {import('../../machinelogic/Library').Library} machineLogicLibrary
 */
function TestHomePage(container, pTargetActuatorUuid, machineLogicLibrary) {
  container.css({ paddingTop: '10px', minHeight: '652px' });

  // Create GUI skeleton (pane layout, containers, etc.), and add data-less components and static elements
  const lTestHomePage = $('<div>').css({display: 'flex', height: '100%', flexFlow: 'column nowrap', position: 'relative',}).appendTo(container);

  // Header
  const lTestHomePageHeader = $('<div>').css({height: '50px', display: "flex", justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px'}).appendTo(lTestHomePage);
  // - Back to Config Button
  cc_widgets.getBacktoConfigButton().appendTo(lTestHomePageHeader);

  // -  Title
  $('<div>').text('Configuration Checker').addClass('cc_header').css({textAlign: 'center', margin: '0px', width: '100%'}).appendTo(lTestHomePageHeader);
  $('<div>').css({width: '100%'}).appendTo(lTestHomePageHeader); // spaceholder

  // Left pane
  const lLeftPane = $('<div>').css({display: 'flex', flexDirection: 'column', width: '280px', marginRight: '5px', border: '1px solid rgb(183, 183, 183)', flexShrink: '0'});
  // - Test Steps
  const lValidationStepsContainer = $('<div>').css({margin: '16px'}).appendTo(lLeftPane);
  // - - Validation Steps Header
  const lValidationStepsHeader = $('<div>').css({display: 'flex', justifyContent: 'space-between'}).addClass('cc_config_header').appendTo(lValidationStepsContainer);
  $('<div>').text('Validation Steps').appendTo(lValidationStepsHeader);
  $('<div>').text(`16 mins`).appendTo(lValidationStepsHeader);
  // - - Actuator's Name
  $('<div>').text(`Validating: ${gActuator.parameters.friendlyName}`).css({fontSize: '13.5px'}).appendTo(lValidationStepsContainer);
  // - - Validation Steps Widget
  const lValidationStepsWidget = cc_widgets.validationStepsWidget();
  lValidationStepsContainer.append(lValidationStepsWidget.element);
  function updateValidationSteps() {
    lValidationStepsWidget.update({
      testPlanInfo: testPlan.map(
        (testDef) => ({
          testDef,
          result: testResults.get(testDef),
          active: testDef === testPlanProgression.getActiveTest(),
          pending: testPlanProgression.isPending(testDef),
        })),
      activeTestDef: testPlanProgression.getActiveTest(),
    });
  }


  // Right pane
  const lRightPane = $('<div>').css({width: '100%', display: 'flex', flexDirection: 'column', flexGrow: '1', marginLeft: '5px', border: '1px solid rgb(183, 183, 183)'});

  // - Step Info Header Widget
  const lStepInfoHeaderWidget = cc_widgets.stepInfoHeaderWidget(restartTestHandler);
  lRightPane.append(lStepInfoHeaderWidget.element);


  // - Content
  const lContent = $('<div>').addClass('center add_scrollbar').css({margin: '0px 10px 10px 10px'}).appendTo(lRightPane);

  // Panes
  const lPanes = $(`<div id="panes" style="display: flex; flex: 1 0 auto; width: 100%; position: relative;"></div>`).appendTo(lTestHomePage);
  lPanes.append([lLeftPane, lRightPane]);

  // Test Definitions
  const testDefs = {
    verifyDriveNumber,
    verifyAxisDirection,
    verifyHomeSensor,
    verifyEndSensor,
  };

  // Intialization Logic
  const testPlan = Object.values(testDefs).sort((a, b) => (a.precedence > b.precedence ? 1 : -1));
  let testPlanProgression;
  const testResults = new Map();


  // Intialize Widgets
  // Update Step Info Header
  lStepInfoHeaderWidget.update({ name: "Planning", number: 1, });
  // Update Validation Steps State
  lValidationStepsWidget.update({
    planningStepInfo: { active: true },
    testPlanInfo: testPlan.map(
      (testDef) => ({
        testDef,
        result: testResults.get(testDef),
      })),
  });




  // - - Actuator Info Widget
  const lActuatorInfoPage = $(`<div style="display: flex; flex-flow: column nowrap; margin: auto; height: 100%; justify-content: center; width: 757px;"></div>`);

  lActuatorInfoPage.append($('<div class="cc_config_header">').text('You are going to validate:')).appendTo(lContent);

  const lActuatorInfo = cc_widgets.driveInfoCard();
  lActuatorInfo.update(gActuator);
  lActuatorInfoPage.append(lActuatorInfo.element);

  const lStartTestButton = $(`<button title="start"></button>`).text('Start Test').css({marginTop :'15px'}).addClass('cc_button_style').appendTo(lActuatorInfoPage);

  lStartTestButton.click(function() {
    // Stop any ongoing motion, also usefull for bringing the actuator out of the shadow realm.
    immediateApi.halt(gActuator.parameters.uuid).catch(() => console.error('Failed to halt.'));

    gLogger.log(`started test plan`);
    lActuatorInfoPage.remove();
    testPlanProgression = new TestPlanProgression(testPlan, gActuator);
    testPlanProgression.setActiveTest(testPlan[0]);
    preTestSetup();
    updateValidationSteps();
    launchActiveTest(machineLogicLibrary);
  });

  // - - Test Workspace, container for cc_widgets.StepWidgets widgets that are displayed during the execution of a step
  const lTestWorkspace = $('<div>').css({display: 'flex', flexFlow: 'column nowrap', rowGap: '25px', margin: 'auto', width: '650px', height: '100%', 'justify-content': 'center'});

  // setup stepConsumer
  cc_widgets.StepWidgets.setStepConsumer((step, groupWithPrevious) => {
    if (!groupWithPrevious) {
      lTestWorkspace.empty();
    }
    lTestWorkspace.append(step.element);
  });
  // setup stepLogger
  cc_widgets.StepWidgets.setLogger(gLogger);

  // -- Post Test Content
  const lPostTestContainer = $('<div>').css({
    height: '100%',
    width: '650px',
    display: 'flex', 'flex-direction': 'column',
    margin: 'auto', 'align-items': 'center', 'justify-content': 'center'
  });
  const lTestResultContainer = $('<div>').appendTo(lPostTestContainer);
  const lPostTestInfoContainer = $('<div>').css({fontSize: '14px', fontStyle: 'italic', textAlign: 'center'}).appendTo(lPostTestContainer);
  const lPostTestButton = $('<button class="cc_button_style">').css({width: '650px', background: '#1AC876', margin: '10px 0px'}).appendTo(lPostTestContainer);
  const lTooltipsContainer = $('<div>').css({paddingBottom: '15px'}).appendTo(lPostTestContainer);

  // Test Navigation Helper Functions
  function preTestSetup() {
    const { friendlyName, desc } = testPlanProgression.getActiveTest();
    lStepInfoHeaderWidget.update({
      name: friendlyName,
      number: testPlan.indexOf(testPlanProgression.getActiveTest()) + 2,
      desc : desc,
    }),
    lContent.append(lTestWorkspace);
  }

  function nextTestHandler() {
    testPlanProgression.setActiveTest(testPlanProgression.getNextTest());
    postTestCleanup();
    preTestSetup();
    launchActiveTest(machineLogicLibrary);
    updateValidationSteps();
  }

  function restartTestHandler(pTestNumber) {
    machinemotion.library(function (pData) {
      if (pData && pData.status == undefined && pData.includes('#global')) {
        // Fetch the the #global application
        machinemotion.application('#global', function (pConfig) {

          const lActuatorConfigObj = pConfig.sequences[0].instructions.find(inst => inst.parameters.uuid == pTargetActuatorUuid);

          gActuator.update(lActuatorConfigObj);

          postTestCleanup();
          if (pTestNumber != undefined) {
            testPlanProgression.setActiveTest(testPlanProgression.testPlan[pTestNumber - 2]);
          } else {
            testPlanProgression.setActiveTest(testPlanProgression.getNextTest());
          }

          preTestSetup();
          launchActiveTest(machineLogicLibrary);
          updateValidationSteps();
        });
      }
    });
  }

  function postTestCleanup() {
    lPostTestInfoContainer.empty();
    lTestResultContainer.empty();
    lPostTestButton.off();
    lPostTestContainer.remove();
    lTooltipsContainer.empty();
  }

  /**
   * @param {import('../../machinelogic/Library').Library} machineLogicLibrary
   */
  function launchActiveTest(machineLogicLibrary) {
    if(!$('#spinner_widget').length) {
      const lSpinner = cc_widgets.spinner();
      lTestWorkspace.append(lSpinner.element);
      lSpinner.element.hide();

      setTimeout(() => { lSpinner.element.show(); }, 250); // grace period before we spin
    }

    lContent.append(lTestWorkspace);

    const lRunner = new Runner({
      testDef: testPlanProgression.getActiveTest(),
      actuator: gActuator,
      ctx: {},
      runListener: {
        started: () => {
          gLogger.log("started test: " + testPlanProgression.getActiveTest().friendlyName);
          updateValidationSteps();
        },
        finished: () => {
          const result = lRunner.result;
          gLogger.log("finished test: " + testPlanProgression.getActiveTest().friendlyName);
          gLogger.log("test result: " + result.status);

          testResults.set(testPlanProgression.getActiveTest(), result);
          testPlanProgression.completedTest(testPlanProgression.getActiveTest());

          lTestWorkspace.empty();
          lTestWorkspace.remove();
          lPostTestButton.removeClass('disabled_button');

          let resultWidget;

          if (result.status == 'passed') {
            resultWidget = cc_widgets.testResultWidget();

            if(!testPlanProgression.hasNextTest()) {
              lPostTestButton.text("See Test Results");
              lPostTestButton.click(() => viewResultsHandler(machineLogicLibrary));
            }
            else {
              if (testPlanProgression.hasPending()) {
                const lPendingTestsIndex = testPlanProgression.testPlan.indexOf(testPlanProgression.getPending()[0]) + 2;
                lPostTestButton.text(`Redo Step ${lPendingTestsIndex}`);
                const lHintText = $('<div>').text(`Changes may have altered the validity of step ${lPendingTestsIndex}, please redo it.`).css({width: '90%', padding: '0px 5%', textAlign: 'center', fontStyle: 'italic', fontSize: '14px'});
                lTooltipsContainer.append(lHintText);
              }
              else {
                lPostTestButton.text("Done");
              }
              lPostTestButton.click(nextTestHandler);
            }
          }
          else if (result.status == 'autofix') {
            testPlanProgression.diagnoses.push(result);
            testPlanProgression.failedActiveTest();
            resultWidget = cc_widgets.testResultWidget();
            const actuatorInfoWidget = cc_widgets.driveInfoCard();
            actuatorInfoWidget.update(gActuator, gInitialActuatorConfig, result.category);
            const lDriveInfoWidget = actuatorInfoWidget.element.css({position: 'relative', /*left: '-183px',*/ marginTop: '10px'});
            const lDriveInfoWidgetContainer = $('<div>').append(lDriveInfoWidget);
            resultWidget.addWidget(lDriveInfoWidgetContainer);
            lPostTestButton.text("Verify");
            lPostTestButton.click( ()=>{ restartTestHandler(); } );
          }
          else if (result.status == 'failed') {
            testPlanProgression.failedActiveTest();
            resultWidget = cc_widgets.testResultWidget();
            lPostTestButton.text("I’ve fixed this. Re-run this step");
            lPostTestButton.click( ()=>{ restartTestHandler(); } );
          }
          else if (result.status == 'diagnose') {
            testPlanProgression.diagnoses.push(result);
            testPlanProgression.failedActiveTest();
            resultWidget = cc_widgets.testDiagnosisWidget(getMlConfig());
            lPostTestButton.text("I’ve fixed this. Re-run this step");
            lPostTestButton.click(() => {
              restartTestHandler();
              if(resultWidget.cleanup) {
                resultWidget.cleanup();
              }
            });


          }
          resultWidget.update(result);
          lTestResultContainer.append(resultWidget.element);

          updateValidationSteps();
          lContent.append(lPostTestContainer);

          if (result.tooltips) {
            result.tooltips.forEach(tip => {
              lTooltipsContainer.append(cc_widgets.getToolTipWidget(tip));
            });
          }

        },
      },
    });

    lRunner.launch();
  }

  /**
   * @param {import('../../machinelogic/Library').Library} machineLogicLibrary
   */
  function viewResultsHandler(machineLogicLibrary) {
    const resultJSON = {
      'parameters' : gActuator.parameters,
      'validatables': {
        'driveNumberValidatable'    : gActuator.driveNumberValidatable,
        'directionValidatable'      : gActuator.directionValidatable,
        'homeSensorValidatable'     : gActuator.homeSensorValidatable,
        'endSensorValidatable'      : gActuator.endSensorValidatable
      },
      'logs': {
        testLog: gLogger.getLogs(),
      },
    };

    const lPayload = {
      'controllerId': gActuator.parameters.controllerId,
      'axisUuid': gActuator.parameters.uuid,
      'result': resultJSON,
    };

    configCheckerPersistency.insertResultForActuator(
      lPayload,
      () => {
        machineLogicLibrary
          .getConfigManager()
          .getAxisByUuid(gActuator.parameters.uuid)
          .updateConfigCheckerResultStatus();
      },
      () => {
        _style.messageBox('Failed to save result', 'error');
      });

    postTestCleanup();
    container.empty();
    cc_widgets.loadReportPage(container, gActuator, gInitialActuatorConfig, testPlanProgression.diagnoses);
  }
}

// --------------------------------------------------
// Parent Widget for Config Checker Main Page
// --------------------------------------------------

function MainPage(mount, navigate, pTargetControllerUuid) {
  const lMainPage = $('<div>').css({display: 'flex', height: '100%', flexFlow: 'column nowrap', position: 'relative',}).appendTo(mount);

  // Header
  const lMainPageHeader = $('<div>').css({height: '50px', display: "flex", justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px'}).appendTo(lMainPage);
  // - Back to Config Button
  cc_widgets.getBacktoConfigButton().css({width: '90%'}).appendTo(lMainPageHeader);
  $('<div>').text('Configuration Checker Status & Past Results').addClass('cc_header').css({textAlign: 'center', margin: '0px', width: '120%'}).appendTo(lMainPageHeader);
  cc_widgets.getDownloadButton(pTargetControllerUuid).css({width: '90%'}).appendTo(lMainPageHeader);

  // Controller Name
  const lControllerName = getMlConfig().getConfiguration(pTargetControllerUuid).getController().getName();
  $('<div>').text(lControllerName).css({fontSize: '14px', fontWeight: 'bold', color: '#2D3A4D', textAlign: 'center'}).appendTo(lMainPage);

  getMlConfig().listAxes()
    .filter(pActuator => pActuator.getControllerId() === pTargetControllerUuid)
    .forEach((pActuator) => {
      if(!pActuator.isNonMotorized() && pActuator.isConfigCheckerCompatible()) {
        configCheckerPersistency.getResultStatus( pActuator.getControllerId(), pActuator.getUUID(), (status) => {
          lMainPage.append(cc_widgets.getActuatorResultCard(pActuator, status, navigate));
        });
      }
    });
}

export function startConfigChecker(container, pTargetActuatorUuid, pTargetControllerUuid, pConfig, machineLogicLibrary, estopManager, navigate) {

  if (!pTargetActuatorUuid && !pTargetControllerUuid) {
    _style.messageBox('No target actuator or controller specified', 'error');
    throw new Error('No target actuator or controller specified');
  }

  setHasConnection(true);

  // TODO GD This code should ultimately live in the pendant. The VSE should not be aware of the pendant routes
  registerLeaveConfigChecker(() => navigate("/machine-config"));

  cc_widgets.setEstopManager(estopManager);
  cc_widgets.applyStyles();

  if (!pTargetActuatorUuid) {
    setMlConfig(machineLogicLibrary.getConfigManager());
    MainPage(container, navigate, pTargetControllerUuid);
    return;
  }

  setMlConfig(machineLogicLibrary.getConfigManager().getAxisByUuid(pTargetActuatorUuid).getConfig());
  const lActuatorConfigObj = pConfig.sequences[0].instructions.find(inst => inst.parameters.uuid === pTargetActuatorUuid);

  if (!lActuatorConfigObj) {
    console.error('Did not find the desired actuator in the Configuration. UUID:' + pTargetActuatorUuid + ' Config:' + pConfig.sequences[0].instructions);
    _style.messageBox('Did not find the desired actuator in the Configuration.', 'error');
    const hostControllerUuid = machineLogicLibrary.getConfigManager().getHostControllerUuid();
    MainPage(container, navigate, hostControllerUuid);
    return;
  }

  // Show Spinner while waiting to receive config
  container.append(cc_widgets.spinner().element.css({margin: '230px 0px'}));
  gActuator = new Actuator(lActuatorConfigObj, () => {
    gInitialActuatorConfig = JSON.parse(JSON.stringify(gActuator));

    gLogger = new Logger();
    if (ECHO) { gLogger.echo(); }

    container.empty();
    stopMotionOnAllControllers(machineLogicLibrary).then(() => {
      TestHomePage(container, pTargetActuatorUuid, machineLogicLibrary);
    });
  });

}
